var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-results"},[_vm._v("\n  "+_vm._s(_vm.$getText('CONTACT_NO_RESULTS', { profileType: _vm.profileTypeText }))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }